import PropTypes from 'prop-types';
import { genderPreferencesTypes, genderTypes } from '../constants/gender';

export default PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  email: PropTypes.string,
  birthDate: PropTypes.string,
  gender: PropTypes.oneOf(genderTypes),
  genderPreferences: PropTypes.oneOf(genderPreferencesTypes),
  numberOfReports: PropTypes.number,
  convertedUrl: PropTypes.string,
  isBlocked: PropTypes.number,
});



// WEBPACK FOOTER //
// ./src/sources/shapes/UserShape.js